import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import ContactForm from '../components/contact/ContactForm';
import ContactInfo from '../components/contact/ContactInfo';
import { useLanguage } from '../context/LanguageContext';
import { useContactForm } from '../hooks/useContactForm';
import { offices } from '../data/mockData';

const Contact = () => {
  const { currentLang, t, isRTL } = useLanguage();
  const officeList = offices[currentLang] || offices.fr;
  const headquarters = officeList[0];

  const {
    formData,
    isSubmitted,
    isLoading,
    errorMessage,
    handleChange,
    handleSubmit,
  } = useContactForm(currentLang);

  return (
    <div className="min-h-screen">
      <Header />
      <main dir={isRTL ? 'rtl' : 'ltr'}>
        <section className="pt-32 pb-20 bg-gradient-to-br from-[#e8d4e5] via-[#d9c5d6] to-[#c5a3c0]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="max-w-3xl"
            >
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                {t.contact.title}
              </h1>
              <p className="text-lg text-gray-700 leading-relaxed">
                {t.contact.description}
              </p>
            </motion.div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-16 ${isRTL ? 'lg:flex-row-reverse' : ''}`}>
              <motion.div
                initial={{ opacity: 0, x: isRTL ? 30 : -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <ContactForm
                  t={t}
                  isRTL={isRTL}
                  formData={formData}
                  isSubmitted={isSubmitted}
                  isLoading={isLoading}
                  errorMessage={errorMessage}
                  onChange={handleChange}
                  onSubmit={handleSubmit}
                />
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: isRTL ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <ContactInfo t={t} isRTL={isRTL} headquarters={headquarters} />
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
